var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarYellow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.7346 48.1546C40.9514 49.7336 40.0211 50.4334 38.6627 49.7216L27.3731 43.7584C26.0147 43.0347 23.7887 43.0287 22.4189 43.7345L11.0779 49.596C9.7138 50.3018 8.78917 49.59 9.01748 48.011L10.9409 34.9182C11.1692 33.3391 10.49 31.1201 9.43413 29.9777L0.610197 20.4856C-0.451414 19.3432 -0.091836 18.1948 1.40926 17.9436L13.886 15.8083C15.3871 15.5511 17.1965 14.1874 17.9042 12.7818L23.7944 1.05269C24.5022 -0.352885 25.6551 -0.352885 26.3514 1.06466L32.1446 12.8356C32.841 14.2532 34.6388 15.6348 36.1399 15.904L48.5996 18.1529C50.1007 18.4221 50.4489 19.5705 49.3815 20.7009L40.4834 30.1153C39.4161 31.2457 38.7198 33.4588 38.9367 35.0438L40.7517 48.1546H40.7346Z",
    fill: "#EEC000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarYellow);
export default __webpack_public_path__ + "static/media/star-yellow.384a723593bad390e5a4c31b5d60ac7c.svg";
export { ForwardRef as ReactComponent };